import React from "react";

export const ContextPropertySelect = (props) => {
    const {value, onChange, options, disabled} = props;

    return (
        <select value={value} onChange={onChange}>
            <option
                className="select-placeholder"
                value=""
                disabled={disabled}
                defaultValue
            >
                Please select an option
            </option>
            {options && options.map((contextProp) => (
                <option key={contextProp.name}>{contextProp.name}</option>
            ))}
        </select>
    )
}